<template>
  <b-container class="my-5">
    <h5>
      Here I share my notes on three machine learning classics.
    </h5>
    <b-row class="mt-5">
      <b-col cols="3" lg="2">
        <img src="./assets/GDL.png" style="width:100%">
      </b-col>
      <b-col>
        <div>Geometric Deep Learning, 2021.</div>
        <div><i>M Bronstein, J Bruna, T Cohen, P Velickovic</i></div>
        <a href="https://www.dropbox.com/scl/fi/b6e1szbbg3j6jqw0np1rv/GeometricDeepLearning.pdf?rlkey=5wmiq2f93f0lw6r3qkzvh60sx&st=y2i0y7u1&dl=0">
          Notes (2024)
        </a>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="3" lg="2">
        <img src="./assets/sutton.jpeg" style="width:100%">
      </b-col>
      <b-col>
        <div>Reinforcement learning: An introduction, 2018.</div>
        <div><i>RS Sutton, AG Barto</i></div>
        <a href="https://www.dropbox.com/s/tm4lsjs2ooolbwt/ReinforcementLearningAnIntroduction.pdf?dl=0">
          Notes (2019)
        </a>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="3" lg="2">
        <img src="./assets/goodfellow.jpeg" style="width:100%">
      </b-col>
      <b-col>
        <div>Deep learning, 2016.</div>
        <div><i>I Goodfellow, Y Bengio, A Courville</i></div>
        <a href="https://www.dropbox.com/s/h994rrs4knvs5gh/DeepLearning.pdf?dl=0">
          Notes (2017)
        </a>
      </b-col>
    </b-row>
    <b-row class="mt-5">
      <b-col cols="3" lg="2">
        <img src="./assets/bishop.jpg" style="width:100%">
      </b-col>
      <b-col>
        <div>Pattern Recognition and Machine Learning, 2006.</div>
        <div><i>CM Bishop</i></div>
        <a href="https://www.dropbox.com/s/eaixjm85z910ats/PatternRecognitionAndMachineLearning.pdf?dl=0">
          Notes (2015)
        </a>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'bookNotes',
};
</script>

<style scoped>

</style>
